export default function BaseCircleIcon({
  children: icon,
  className = '',
  iconClassName = '',
  style = {},
  iconStyle = {},
  iconPadding = '21px',
}) {
  return (
    <div
      style={{
        position: 'relative',
        padding: iconPadding,
        color: '#fff',
        fill: '#fff',
        borderRadius: '9999px',
        ...style,
      }}
      className={className}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.5rem',
          lineHeight: '2rem',
        }}
      >
        <div style={iconStyle} className={iconClassName}>
          {icon}
        </div>
      </div>
    </div>
  );
}
